import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import { Link as RouterLink } from "react-router";

export const Reconciliation = () => {
  return (
    <Box>
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 700 }}
      >
        Reconciliation
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Button
          component={RouterLink}
          to="dispatch"
          variant="outlined"
          size="large"
          startIcon={<LocalShippingIcon />}
          sx={{
            minWidth: 220,
            justifyContent: "flex-start",
            py: 2,
          }}
        >
          Dispatch
        </Button>

        <Button
          component={RouterLink}
          to="inventory"
          variant="outlined"
          size="large"
          startIcon={<Inventory2Icon />}
          sx={{
            minWidth: 220,
            justifyContent: "flex-start",
            py: 2,
          }}
        >
          Inventory
        </Button>
      </Box>
    </Box>
  );
};
